<template>
  <sh-modal
    label="RSM Assistant Issue"
    id="issue-modal"
    modal-height="500px"
    modal-width="650px"
    @modal-closed="closeIssueModal"
  >
    <div
      style="
        text-align: left;
        margin-top: 50px;
        margin-left: 50px;
        margin-right: 50px;
        margin-bottom: 50px;
      "
    >
      <div style="display: flex">
        <div>
          <sh-text style="margin-bottom: 16px; margin-top: 10px"
            >In your opinion, how severe is the issue?
          </sh-text>
        </div>

        <div style="margin-left: auto; margin-right: 0">
          <sh-dropdown label="Severity" :value="appIssueSeverity">
            <sh-menu-item
              style="text-align: left"
              v-for="(item, index) in severityDeg"
              :key="index"
              :label="item"
              :active="item == appIssueSeverity"
              @click="setAppIssueSeverity(index)"
            >
            </sh-menu-item>
          </sh-dropdown>
        </div>
      </div>
      <div style="margin-top: 16px">
        <sh-text
          ><strong> Low </strong>
          <small> - No impact on your assessment of the recommendations </small>
        </sh-text>
        <sh-text
          ><strong> Medium </strong>
          <small>
            - Have an impact on your assessment of the recommendations
          </small>
        </sh-text>
        <sh-text>
          <strong> High </strong> <small> - Unable to take actions </small>
        </sh-text>
      </div>
      <div style="margin-top: 16px">
        <sh-input-text
          textarea
          rows="5"
          :value="appIssueInput"
          @value-changed="setAppIssueInput($event)"
          label="Please describe the issue here:"
        ></sh-input-text>
      </div>
      <div style="margin-top: 16px">
        <sh-button
          size="m"
          label="Submit"
          :disabled="!appIssueSeverity"
          @click="submitIssue"
        >
        </sh-button>
      </div>
    </div>
  </sh-modal>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "IssueModal",
  components: {},
  props: [],
  data() {
    return {
      appIssueInput: "",
      appIssueSeverity: "",
      severityDeg: ["Low", "Medium", "High"],
    };
  },
  mounted() {},
  created() {},
  beforeUnmount() {
    console.log("Issue component destroyed!");
  },
  computed: {
    ...mapGetters(["backendURL"]),
    ...mapGetters("oidcStore", ["oidcUser"]),
  },
  methods: {
    ...mapActions(["pushNotification"]),
    getCurrentDate() {
      var m = new Date();
      var dateString =
        m.getUTCFullYear() +
        "/" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "/" +
        ("0" + m.getUTCDate()).slice(-2) +
        " " +
        ("0" + m.getUTCHours()).slice(-2) +
        ":" +
        ("0" + m.getUTCMinutes()).slice(-2) +
        ":" +
        ("0" + m.getUTCSeconds()).slice(-2);
      return dateString;
    },

    closeIssueModal() {
      document.querySelector("#issue-modal").visible = false;
      this.appIssueInput = "";
      this.appIssueSeverity = "";
    },

    setAppIssueInput($event) {
      this.appIssueInput = $event.target.value;
    },

    setAppIssueSeverity(index) {
      this.appIssueSeverity = this.severityDeg[index];
    },

    submitIssue() {
      let payload = {
        username: this.oidcUser ? this.oidcUser.email : "",
        time: this.getCurrentDate(),
        comment: this.appIssueInput,
        severity: this.appIssueSeverity,
        category: "issue",
      };
      console.log(payload);

      axios
        .post(this.backendURL + "/api/application_feedback", payload)
        .then((res) => {
          console.log("issue submitted: ", res.data);
          let notification = {
            type: "success",
            label: "Issue received",
            duration: "short",
            text: "Issue submitted!",
          };
          this.pushNotification(notification);
        })
        .catch((err) => {
          console.log(err);
          let notification = {
            type: "error",
            label: "Issue error",
            duration: "short",
            text: "Issue was not submitted!",
          };
          this.pushNotification(notification);
        });

      this.closeIssueModal();
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss"></style>
